import { Chip } from '@mui/material';
import { cn } from 'cn';
import { INCOTERMS_I18N_MAP } from '~/constants';

export function getIncotermLabel(code: string) {
  return (
    INCOTERMS_I18N_MAP()[code as keyof ReturnType<typeof INCOTERMS_I18N_MAP>] ??
    code
  );
}

export function resolveContractItemIncoterm({
  contractIncoterm,
  itemIncoterm,
}: {
  contractIncoterm: string | null | undefined;
  itemIncoterm: string | null | undefined;
}) {
  if (itemIncoterm) {
    return { code: itemIncoterm, source: 'item' as const };
  }

  if (contractIncoterm) {
    return { code: contractIncoterm, source: 'contract' as const };
  }

  return { code: null, source: null };
}

export function IncotermSourceChip({
  className,
  label,
  style,
}: {
  readonly label: string;
} & ComponentStyling) {
  return (
    <Chip
      className={cn(
        'h-auto max-w-full bg-black/12 py-1 text-sm font-medium [&_.MuiChip-label]:break-words [&_.MuiChip-label]:whitespace-normal',
        className,
      )}
      label={label}
      style={style}
      variant="filled"
    />
  );
}
